import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { verifyAdmin } from "@/lib/api";

const AdminProtectedRoute = ({ children }) => {
  const [checking, setChecking] = useState(true);
  const [allowed, setAllowed] = useState(false);
  const location = useLocation();

  useEffect(() => {
    let mounted = true;
    (async () => {
      const ok = await verifyAdmin();
      if (!mounted) return;
      setAllowed(ok);
      setChecking(false);
    })();
    return () => {
      mounted = false;
    };
  }, []);

  if (checking) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0a0a0a]">
        <div className="flex items-center gap-3 text-white/65 text-sm tracking-[0.2em] uppercase">
          <span className="h-2 w-2 rounded-full bg-[color:var(--sp-gold)] animate-pulse" />
          Verifying access
        </div>
      </div>
    );
  }
  if (!allowed) {
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }
  return children;
};

export default AdminProtectedRoute;
